import React from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "../components/Typography";
import { HeaderMenu } from "../components/Header";
import Slider from "../components/Slider";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import VideoBox2 from "../components/VideoBox2";
import VideoBox1 from "../components/VideoBox1";
import MobileSlider from "../components/mobile/MobileSlider";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
// import { StepLearning1 } from "../components/StepLearning1";
// import { StepLearning2 } from "../components/StepLearning2";
// import { MStepLearning1 } from "../components/mobile/MobileStepLearning1";
// import { MStepLearning2 } from "../components/mobile/MobileStepLearning2";
import MentalSlider from "../components/MentalSlider";
import MobileMentalSlider from "../components/mobile/MobileMentalSlider";
import learning11Step from "../asset/learning11Step.png";
import learning11StepM from "../asset/learning11StepM.png";
import learning12Step from "../asset/learning12Step.png";
import learning12StepM from "../asset/learning12StepM.png";
import halfCircleBlue from "../asset/half_circle_blue.png";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: 2500,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "20px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "100%",
    },
  },
  body: {
    width: "100%",
    flexGrow: 1,
    alignSelf: "center",
    display: "flex",
    flexDirection: "column",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxHeight: 4250,
      width: "100%",
      margin: "12px 20px",
      borderTop: "none",
    },
  },
  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    color: "#204FA1",
    maxWidth: 1290,
    fontSize: 18,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 18,
      width: "100%",
      justifyContent: "flex-start",
      marginLeft: 30,
    },
  },
  box: {
    display: "flex",
    placeContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      flexDirection: "column",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      margin: "0px 20px",
    },
  },
  container2: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",

    [theme.breakpoints.down(MobileWeb.mobile)]: {
      margin: "0px 20px",
    },
  },
  poster: {
    width: "854px",
    maxHeight: "850px",
    height: "850px",
    marginBottom: "20px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      display: "flex",
      width: "100%",
      maxHeight: "650px",
      height: "550px",
    },
  },
  BlackLine: {
    width: 853,
    borderTop: "1px solid #000",
    marginTop: "6px",
    marginBottom: "25px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
    },
  },
  topContent1: {
    display: "block",
    width: "853px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
    },
  },
  topContent2: {
    display: "block",
    width: "868px",
    position: "relative",
    left: "-27px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px 20px",
    },
  },
  topContent3: {
    display: "block",
    width: "853px",
    position: "relative",
    alignSelf: "center",
    left: 110,
    [theme.breakpoints.down(MobileWeb.mobile)]: {},
  },
  topContent4: {
    display: "block",
    width: "853px",
    position: "relative",
    alignSelf: "center",
    left: 45,
    [theme.breakpoints.down(MobileWeb.mobile)]: {},
  },
  headerBox: {
    width: "854px",
    height: "42px",
    color: "#fff",
    backgroundColor: "#B290FE",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "20px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      marginTop: "20px",
    },
  },
  videoBox: {
    display: "flex",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
    },
  },
  loginBox: {
    width: "854px",
    height: "42px",
    color: "#fff",
    backgroundColor: "#EB5FE5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px",
    marginBottom: "124px",
    borderRadius: "4px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
    },
  },
  moduleBox: {
    position: "relative",
    display: "inline-block",
    textAlign: "center",
    width: "156px",
    height: "156px",
    backgroundColor: "#EB5FE5",
    marginRight: "18px",
    "&:last-child": {
      marginRight: "0px",
    },
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "100%",
    },
  },
  bottomContent: {
    width: "852px",
    position: "relative",
    display: "flex",
    marginTop: "30px",
    marginBottom: "85px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      flexDirection: "column",
    },
  },
  li: {
    listStyleType: "'\\2012'",
    textAlign: "justify",
  },
  slider: {
    display: "block",
    // left: 355,
    position: "relative",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  slider2: {
    display: "block",
    // left: 430,
    position: "relative",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  mobileSlider: {
    display: "none",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      display: "block",
      width: "100%",
      textAlign: "-webkit-center",
    },
  },
  stepL: {
    display: "flex",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  mStepL: {
    display: "none",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "flex",
      height: "100%",
    },
  },
  learningStep: {
    marginBottom: 50,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  learningStepM: {
    display: "none",

    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "block",
      width: "100%",
      marginBottom: 30,
    },
  },
  topTextBox: {
    display: "flex",
    alignSelf: "center",
    flexDirection: "column",
    position: "relative",
    right: 390,
    marginTop: 30,
    marginBottom: 60,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
      width: "100%",
    },
  },
  halfCircleBlue: {
    position: "relative",
    bottom: 5,
    right: 30,
    width: 65,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
      bottom: 5,
    },
  },
}));

export const SimContentPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.container}>
          <div className={classes.topTextBox}>
            <img
              src={halfCircleBlue}
              alt="blueHalfCircle"
              className={classes.halfCircleBlue}
            />
            <Typography variant="H3" className={classes.top_text}>
              사업내용
            </Typography>
          </div>
          <div className={classes.topContent1}>
            <Typography
              variant="ContentHeader"
              style={{
                paddingLeft: "20px",
                position: "relative",
              }}
            >
              1. 간호관리
            </Typography>
          </div>

          <div className={classes.BlackLine}></div>
          <div className={classes.topContent2}>
            <div>
              <Typography
                variant="Content1"
                style={{ display: "block", lineHeight: "30px" }}
              >
                <ul style={{ width: "95%" }}>
                  <li className={classes.li}>
                    한국간호행정학회에서 제시한 간호관리학 학습목표를 반영하여
                    간호단위관리 실습 주제별로 사례를 구성함
                  </li>
                  <li className={classes.li}>
                    임상 현장에서의 간호관리 활동을
                    기획-조직-인적자원관리-지휘-통제의 간호관리과정을의 5요소를
                    토대로 비판적 사고와 의사결정 과정을 통해 학습하도록
                    시뮬레이션 과정을 설계함
                  </li>
                  <li className={classes.li}>
                    한국간호교육평가원에서 제시한 표준 학습성과를 바탕으로 각
                    사례의 시뮬레이션 실습을 통해 학생들이 실습하게 되는
                    학습성과를 맵핑하고, 학생별 학습성과별 성취도(CQI 보고서
                    용)를 교수자가 확인할 수 있도록 별도의 교수자 플렛폼을
                    설계함
                  </li>
                </ul>
              </Typography>
            </div>
          </div>
        </div>
        <>
          <Typography
            variant="ContentHeader"
            style={{ display: "flex", justifyContent: "center", marginTop: 50 }}
          >
            관리실습 모듈 5개 사례 주제 구성
          </Typography>
          <div className={classes.topContent3}>
            <div className={classes.slider2}>
              <Slider />
            </div>
          </div>
          <div className={classes.container}>
            <div className={classes.mobileSlider}>
              <MobileSlider />
            </div>
          </div>
        </>

        <div className={classes.box} style={{ marginTop: 20 }}>
          <div className={classes.container2}>
            <img
              src={learning11Step}
              alt="단계별학습11STEP"
              className={classes.learningStep}
            />
            <img
              src={learning11StepM}
              alt="단계별학습11STEP모바일"
              className={classes.learningStepM}
            />

            {/* 구학습STEP */}
            {/* <div className={classes.headerBox}>
              <Typography variant="ContentHeader">
                1) 단계별 학습 11 STEP
              </Typography>
            </div>
            <div className={classes.poster} style={{}}>
              <div className={classes.stepL}>
                <StepLearning1 />
              </div>
              <div className={classes.mStepL}>
                <MStepLearning1 />
              </div>
            </div> */}
            {/* 구학습STEP */}

            <VideoBox1></VideoBox1>

            <div className={classes.loginBox}>
              <Typography variant="ContentHeader2"></Typography>
            </div>
          </div>
        </div>

        <div className={classes.container}>
          <div className={classes.topContent1}>
            <Typography
              variant="ContentHeader"
              style={{ paddingLeft: "20px", position: "relative" }}
            >
              2. 정신간호
            </Typography>
          </div>
          <div className={classes.BlackLine}></div>
          <div className={classes.topContent2}>
            <div>
              <Typography
                variant="Content1"
                style={{ display: "block", lineHeight: "30px" }}
              >
                <ul style={{ width: "93%" }}>
                  <li className={classes.li}>
                    청소년 자해, 알코올 사용 장애 등 다양한 문제 상황을 중심으로
                    사례 구성
                  </li>
                  <li className={classes.li}>
                    교육 현장에서 요구하는 실습 케이스를 제공
                  </li>
                </ul>
              </Typography>
            </div>
          </div>
        </div>

        <>
          <Typography
            variant="ContentHeader"
            style={{ display: "flex", justifyContent: "center", marginTop: 20 }}
          >
            정신간호 관리실습 모듈 5개 구성
          </Typography>
          <div className={classes.topContent4}>
            <div className={classes.slider}>
              <MentalSlider />
            </div>
          </div>
          <div className={classes.container}>
            <div className={classes.mobileSlider}>
              <MobileMentalSlider />
            </div>
          </div>
        </>

        <div className={classes.box}>
          <div className={classes.container}>
            <img
              src={learning12Step}
              alt="단계별학습12STEP"
              className={classes.learningStep}
            />
            <img
              src={learning12StepM}
              alt="단계별학습12STEP모바일"
              className={classes.learningStepM}
            />
            {/* 구학습STEP */}
            {/* <div className={classes.headerBox}>
              <Typography variant="ContentHeader">
                2) 단계별 학습 12 STEP
              </Typography>
            </div>
            <div className={classes.poster}>
              <div className={classes.stepL}>
                <StepLearning2 />
              </div>
              <div className={classes.mStepL}>
                <MStepLearning2 />
              </div>
            </div> */}
            {/* 구학습STEP */}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <VideoBox2></VideoBox2>
            </div>

            <div className={classes.loginBox}>
              <Typography variant="ContentHeader2"></Typography>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>

      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};
